import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hook";
import { createConversationAndSetVoiceId as createConversationAndSetVoiceIdAPI, getAllVoices, getVoiceLanguages as getVoiceLanguagesAPI, rateVoiceQuality as rateVoiceQualityAPI, saveConversationVoiceId, } from "./voiceSlice";
/** Module-level cache so voice languages persist across component mount/unmount (e.g. navigation). */
let voiceLanguagesCache = null;
export default function useVoice() {
    const dispatch = useAppDispatch();
    const voiceState = useAppSelector((state) => state.voices);
    const allVoices = voiceState?.allVoices;
    const loading = voiceState?.loading;
    const getVoices = useCallback(async () => {
        try {
            if (allVoices?.length || loading?.isLoading)
                return;
            await dispatch(getAllVoices()).unwrap();
        }
        catch (err) {
            throw new Error(err?.message);
        }
    }, [allVoices?.length, loading?.isLoading]);
    const setConversationVoiceId = useCallback(async (conversation_id, voice_id) => {
        try {
            if (!conversation_id || !voice_id)
                return;
            const payload = {
                conversation_id,
                voice_id,
            };
            return await dispatch(saveConversationVoiceId(payload)).unwrap();
        }
        catch (err) {
            throw new Error(err?.message);
        }
    }, []);
    const rateVoiceQuality = useCallback(async (payload) => {
        try {
            if (!payload.message_id || !payload.voice_id || !payload.label)
                return;
            return await dispatch(rateVoiceQualityAPI(payload)).unwrap();
        }
        catch (err) {
            throw new Error(err?.message);
        }
    }, []);
    const createConversationAndSetVoiceId = useCallback(async (characterId, defaultPersonaId, selectedVoiceId) => {
        try {
            if (!characterId || !defaultPersonaId || !selectedVoiceId)
                return;
            return await dispatch(createConversationAndSetVoiceIdAPI({
                characterId,
                defaultPersonaId,
                selectedVoiceId,
            })).unwrap();
        }
        catch (err) {
            throw new Error(err?.message);
        }
    }, []);
    const getVoiceLanguages = useCallback(async () => {
        try {
            if (voiceLanguagesCache)
                return voiceLanguagesCache;
            const result = await dispatch(getVoiceLanguagesAPI()).unwrap();
            voiceLanguagesCache = result;
            return result;
        }
        catch (error) {
            throw new Error(error?.message);
        }
    }, [dispatch]);
    const clearVoiceLanguagesCache = useCallback(() => {
        voiceLanguagesCache = null;
    }, []);
    return {
        getVoices,
        setConversationVoiceId,
        rateVoiceQuality,
        createConversationAndSetVoiceId,
        getVoiceLanguages,
        clearVoiceLanguagesCache,
        allVoices,
        loading,
    };
}
